import { render, staticRenderFns } from "./ChatFooter.vue?vue&type=template&id=47b02bfb&scoped=true"
import script from "./ChatFooter.vue?vue&type=script&lang=js"
export * from "./ChatFooter.vue?vue&type=script&lang=js"
import style0 from "./ChatFooter.vue?vue&type=style&index=0&id=47b02bfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b02bfb",
  null
  
)

export default component.exports